module.exports = __webpack_public_path__ + "media/pro/NTRS-78fc4dc6.png";